// extracted by mini-css-extract-plugin
export default {"advertCardList":"c-a_gV","advertCardList_max6":"c-a_gW"};